var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAchievements1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0697 27.6667H19.0697C25.7363 27.6667 28.403 25 28.403 18.3333V10.3333C28.403 3.66667 25.7363 1 19.0697 1H11.0697C4.40299 1 1.73633 3.66667 1.73633 10.3333V18.3333C1.73633 25 4.40299 27.6667 11.0697 27.6667Z",
    stroke: "#1F1A26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6384 8.61803C16.0397 6.77542 13.4329 6.77541 12.8342 8.61803L12.2137 10.5279H10.2056C8.26812 10.5279 7.46256 13.0071 9.02999 14.1459L10.6546 15.3262L10.034 17.2361C9.43534 19.0787 11.5443 20.6109 13.1117 19.4721L14.7363 18.2918L16.3609 19.4721C17.9284 20.6109 20.0373 19.0787 19.4386 17.2361L18.8181 15.3262L20.4427 14.1459C22.0101 13.0071 21.2045 10.5279 19.2671 10.5279L17.259 10.5279L16.6384 8.61803Z",
    stroke: "#1F1A26",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievements1);
export default __webpack_public_path__ + "static/media/achievements1.9b13866f24e9df1be9015227de1301e7.svg";
export { ForwardRef as ReactComponent };